import PercentMetric from './PercentMetric';

export default PercentMetric;
